<template>
  <div>
    <section class="time-off-report-page container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-table-header super full-height-page-wrapper" :class="{ page: isPage }">
            <PageHeader showBreadcrumbs :customBreadcrumbs="pageCrumbs" :page-title="pageTitle">
              <template #buttons>
                <DatePeriodNavigation :start-date="selectedYearDate" :disable-prev="isFirstYearSelected"
                  :disable-next="isLastYearSelected" :single-mode="true" minimum-view="year" date-format="yyyy"
                  @changePeriod="handleYearChange" @selectDate="handleYearSelect" />
                <div class="d-flex align-items-center">
                  <CloseButton v-if="!isPage" :onClick="onClose" buttonClass="pt-0" />
                </div>
              </template>
            </PageHeader>
            <div v-if="isLoading" class="content-loading-wrapper" style="position: absolute;">
              <Preloader class="centered-preloader large-spinner" customClasses="time-log-loader" />
            </div>

            <div :style="{
              'border-radius': '10px',
              'background-color': '#fff'
            }">
              <div class="row" style="padding: 16px 14px;">
                <div class="col col-md-2">
                  <label class="form__label">Select user</label>
                  <multiselect v-model="selectedUser" :options="userOptions" placeholder="Select a user" label="name"
                    track-by="name" :class="{ 'multiselect__single-line': true }" :allow-empty="false"
                    :showLabels="false" @select="getReportPage" />
                </div>
              </div>

              <EmptyStateNoResults v-if="!selectedUser && (!selectedUserId || userFetchError)" withoutButton :customSvg="hourglassBottomIconSvg"
                title="No user selected" description="Choose a user to see their detailed time off data." />

              <template v-if="!isLoading">
                <div class="table-responsive-outter-wrapper" v-if="
                  reportsData.length &&
                  selectedYearData &&
                  tableData.length
                ">
                  <div class="table-responsive-wrapper" :style="{
                    width: shouldUseFullWidth ? '100%' : 'min-content'
                  }">
                    <TableForPage :fields="tableColumns" :tableData="tableData" :slots="reportSlots"
                      class="time-off-user-table" @update="updateTable" :stickyHeader="false" :colGroups="colGroups">
                      <template v-slot:index="slotProps">
                        <IndexColumn :index="slotProps.index" :currentPage="currentPage" :itemsPerPage="perPage"
                          :isLoading="isLoading" />
                      </template>
                      <template v-slot:name="slotProps">
                        <TableUserItem :user="slotProps.item.user" :number="getNumber(slotProps.index)" />
                      </template>

                      <template v-slot:head(worked_days)="slotProps">
                        <div style="
                  display: flex;
                  align-items: center;
                  gap: 2px;
                ">
                          Workdays passed
                          <span class="material-symbols-outlined" style="
                      font-size: 14px;
                      width: 14px;
                      height: 14px;
                      cursor: help;
                    " v-b-tooltip.hover="{ variant: 'base', placement: 'top', boundary: 'viewport', delay: { show: 300, hide: 0 } }"
                            title="Includes regular workdays and time offs that allow continuing to accrue other leave.">
                            info
                          </span>
                        </div>
                      </template>

                      <template v-slot:[`head(${item.key})`]="slotProps" v-for="item in colGroups">
                        <div class="d-flex align-items-center justify-content-center" style="
                    text-transform: none !important;
                  " :style="{
                    minWidth: item.colspan === 1 ? '121px' : '170px'
                  }" :key="item.key">
                          <div class="d-flex align-items-center justify-content-center">
                            <TimeOffIcon v-if="item.icon" :name="item.icon.icon"
                              :style="{ color: item.icon.color, minWidth: 'fit-content' }" />
                            <span class="pl-2 text-center">{{ item.key.toUpperCase() }}</span>
                          </div>
                        </div>
                      </template>

                      <template v-slot:[`${item}`]="slotProps" v-for="item in Object.keys(dynamicUserSlots)">
                        <div :key="item">
                          <span>{{ `${slotProps.item[`${item}`]}` }}</span>
                          <span v-if="slotProps.item[`${item}adjust`]" :style="`color: ${slotProps.item[`${item}adjust`] < 0 ? '#DC3545' : '#3FA52F'
                            }`">
                            ({{
                              slotProps.item[`${item}adjust`] >= 0
                                ? "+" + slotProps.item[`${item}adjust`]
                                : "" + slotProps.item[`${item}adjust`]
                            }})
                          </span>
                        </div>
                      </template>

                      <template v-slot:action="slotProps">
                        <div class="actions-wrap">
                          <span :id="`${slotProps.item.user.id}-action`" class="material-symbols-outlined icon-color"
                            @click="() => visibilityActionClick(slotProps)">
                            visibility
                          </span>
                          <span @click="() => handleEditClick(slotProps.item.user.id)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20"
                              fill="none">
                              <path
                                d="M12.2167 7.51667L12.9833 8.28333L5.43333 15.8333H4.66667V15.0667L12.2167 7.51667ZM15.2167 2.5C15.0083 2.5 14.7917 2.58333 14.6333 2.74167L13.1083 4.26667L16.2333 7.39167L17.7583 5.86667C18.0833 5.54167 18.0833 5.01667 17.7583 4.69167L15.8083 2.74167C15.6417 2.575 15.4333 2.5 15.2167 2.5ZM12.2167 5.15833L3 14.375V17.5H6.125L15.3417 8.28333L12.2167 5.15833Z"
                                fill="#3D5170" />
                            </svg>
                          </span>
                        </div>
                      </template>

                      <template v-slot:row="slotProps">
                        <div v-if="
                          userDetailsDataLoading &&
                          userDetailsDataLoading == slotProps.row.item.user.id
                        " class="p-2 d-flex justify-content-center">
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                        <TimeOffReportDetailsRow v-if="detailsData[slotProps.row.item.user.id]" :rowData="slotProps.row"
                          :detailsData="detailsData[slotProps.row.item.user.id]" :selectedYear="selectedYear"
                          :showModalOnInit="showModalOnInit" :slotProps="slotProps" :userId="slotProps.row.item.user.id"
                          @dataUpdated="dataUpdated" @showAdjustModal="handleEditClick" />
                      </template>
                    </TableForPage>
                  </div>
                </div>

                <div v-else-if="
                  (reportsData.length ||
                    !tableData.length) && selectedUser
                ">
                  <EmptyStateNoResults withoutButton :customSvg="hourglassBottomIconSvg"
                    title="No time off report - detailed yet" description="No time off data available for this year." />
                </div>
              </template>
            </div>

            <template v-if="!isLoading && !hideMonthsSection">
              <div :style="{
                'margin-top': '20px',
                'border-radius': '10px',
                'background-color': '#fff'
              }">
                <div class="used-by-months-table-wrapper" :style="{
                  width: shouldUseFullWidthForMonths ? '100%' : 'min-content',
                }" v-if="selectedYearMonthsData && monthsTableData && monthsTableData.length">
                  <div class="table-responsive-wrapper">
                    <TableForPage title="Used by months" :fields="monthsTableColumns" :slots="monthsSlots"
                      :tableData="monthsTableData" :stickyHeader="false"
                      tableClass="table-layout-fixed used-by-months-table">
                      <template v-slot:month="slotProps">
                        <div class="d-flex align-items-center gap-5"
                          :class="slotProps.item.items.length && 'cursor-pointer'" @click="
                            slotProps.item.items.length && slotProps.toggleDetails()
                            ">
                          <span :class="`material-symbols-outlined material-symbols-fill-1 user-select-none ${!slotProps.item.items.length && 'color-text-none'
                            }`" :style="{
                              transform: slotProps.detailsShowing
                                ? 'rotate(180deg)'
                                : 'none',
                              transition: '0.2s',
                            }">
                            keyboard_arrow_down
                          </span>
                          <span>
                            {{ slotProps.item.month }}
                          </span>
                        </div>
                      </template>

                      <template v-slot:[`head(${item.key})`]="slotProps" v-for="item in monthsDynamicTableColumns">
                        <div class="align-items-center justify-content-center" style="
                      text-transform: none !important;
                      display: flex;
                      gap: 12px;
                    " :style="{
                      minWidth: getColumnMinWidth(item.label.text)
                    }" :key="item.key">
                          <div class="d-flex align-items-center justify-content-center">
                            <TimeOffIcon v-if="item.label.icon" :name="item.label.icon.icon"
                              :style="{ color: item.label.icon.color, minWidth: 'fit-content' }" />
                            <span class="pl-2 text-center">{{ item.label.text }}</span>
                          </div>
                          <span style="white-space: nowrap;">{{ item.label.value }}</span>
                        </div>
                      </template>

                      <template v-slot:[`${item}`]="slotProps" v-for="item in Object.keys(monthsDynamicSlots)">
                        <span :key="item" v-if="getMonthTimeOffSum(slotProps.item, item)">
                          {{ getMonthTimeOffSum(slotProps.item, item) }}
                        </span>
                        <NoDataText v-else :key="item + 'none'" />
                      </template>

                      <template v-slot:row="slotProps">
                        <table class="table b-table months-subtable" style="
                      width: calc(100% + 20px);
                      margin: -10px;
                      background-color: #f3f5f7;
                    ">
                          <thead style="visibility: hidden; height: 0; opacity: 0; line-height: 0;">
                            <tr>
                              <th class="">Months</th>
                              <th class="item-width text-center nested-table-left-border nested-table-right-border"
                                v-for="(e, i) in monthsDynamicTableColumns" :key="i + 'header'" :style="{
                                  minWidth: getColumnMinWidth(e.label.text, 21),
                                  width: getColumnMinWidth(e.label.text, 21) + ' !important'
                                }">
                                <div class="align-items-center"
                                  style="text-transform: none !important; display: flex; gap: 12px;">
                                  <div class="d-flex align-items-center justify-content-center">
                                    <TimeOffIcon v-if="e.label.icon" :name="e.label.icon.icon"
                                      :style="{ color: e.label.icon.color, minWidth: 'fit-content' }" />
                                    <span class="pl-2 text-center">{{ e.label.text }}</span>
                                  </div>
                                  <span>{{ e.label.value }}</span>
                                </div>
                              </th>
                              <th class="column-controls-md"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in slotProps.row.item.items" :key="index + 'item'"
                              class="detailed-dates-row">
                              <td class="">
                                <span style="padding: 0 25px">
                                  {{ item.date }}
                                </span>
                              </td>
                              <td class="item-width text-center nested-table-left-border nested-table-right-border"
                                v-for="(e, i) in monthsDynamicTableColumns" :key="i + 'el'" :style="{
                                  minWidth: getColumnMinWidth(e.label.text, 21),
                                  width: getColumnMinWidth(e.label.text, 21) + ' !important'
                                }">
                                <div class="text-center" v-if="e.key === item.type">
                                  {{ item.days }} d
                                </div>
                                <span v-else class="color-text-none" style="visibility: hidden;">none</span>
                              </td>
                              <td class="column-controls-md"></td>
                            </tr>
                          </tbody>
                        </table>
                      </template>
                    </TableForPage>
                  </div>
                </div>

                <div v-else-if="!selectedYearMonthsData && tableData.length" style="padding: 10px 20px;">
                  <p class="table-title">Used by months</p>
                  <div style="padding: 60px 0;">
                    <EmptyStateNoResults withoutButton withoutIcon title=""
                      description="No time off data available for this year." />
                  </div>
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>
    </section>

    <!-- Adjust Modal -->
    <b-modal size="lg" hide-footer v-model="isShowAdjustModal" centered>
      <template v-slot:modal-header="{ cancel }">
        <ModalHeader title="Add adjustments" :onCloseButton="cancel" closeButtonId="adjustModal" />
      </template>
      <FormGenerator ref="form" :data="adjustModalFields" textButtonSubmit="Save" textButtonReset="Cancel"
        @submit="submitAdjustment" @updateItem="updateAdjustModalItem" @reset="closeAdjustModal">
        <template v-slot:allowed="slotProps">
          <b-form-group>
            <label class="form__label">{{ slotProps.data.label }}</label>
            <b-form-input type="text" :placeholder="slotProps.data.placeholder" v-model="slotProps.data.value"
              readonly />
            <slot name="errors"></slot>
          </b-form-group>
        </template>
        <template v-slot:description="slotProps">
          <b-form-group>
            <label class="form__label">{{ slotProps.data.label }}</label>
            <b-form-textarea id="textarea" :value="adjustModalFields.description.value"
              @input="(value) => { updateDescriptionValue(value); slotProps.data.value = value }"
              :placeholder="slotProps.data.placeholder" rows="2" max-rows="6" />
          </b-form-group>
        </template>
      </FormGenerator>
      <div class="d-flex align-items-center text-left" style="margin-top: -25px;">
        <span class="material-symbols-outlined icon-color mr-2">visibility</span>
        <template v-if="isPayable">
          This is payable time off
        </template>
        <template v-else>
          This is not payable time off
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TableForPage from '@tables/TableForPage'
import IndexColumn from '@components/tables/elements/Index'
import TableUserItem from '@components/tables/TableUserItem'
import TimeOffReportDetailsRow from '@components/tables/elements/TimeOffReportDetailsRow'
import CloseButton from '@components/common/CloseButton.vue'
import PageHeader from '@components/PageHeader.vue'
import NoDataText from '@components/common/NoDataText'
import Preloader from '@components/Preloader'
import { mapGetters, mapActions } from 'vuex'
import TimeOffIcon from '@components/TimeOffIcon.vue'
import EmptyStateNoResults from '@components/EmptyStateNoResults'
import FormGenerator from '@components/FormGenerator'
import ModalHeader from '@components/modals/ModalHeader.vue'
import DatePeriodNavigation from '@components/DatePeriodNavigation.vue'
import moment from 'moment'
import hourglassBottomIconSvg from '@/assets/icons/hourglassBottomIcon'

export default {
  name: 'TimeOffReport',
  components: {
    TableForPage,
    IndexColumn,
    TableUserItem,
    TimeOffReportDetailsRow,
    CloseButton,
    PageHeader,
    NoDataText,
    Preloader,
    TimeOffIcon,
    EmptyStateNoResults,
    FormGenerator,
    ModalHeader,
    DatePeriodNavigation
  },
  props: {
    isPage: {
      type: Boolean,
      default: true
    },
    timeOffReportUserId: {
      type: Number,
      default: null
    },
    timeOffReportUser: {
      type: Object
    },
    hideMonthsSection: {
      type: Boolean,
      default: false
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close'],
  data () {
    return {
      hourglassBottomIconSvg: hourglassBottomIconSvg({ size: 'lg' }),
      isLoading: true,
      userDetailsDataLoading: 0,
      detailsData: {},
      currentPage: 1,
      perPage: 15,
      reportsData: [],
      monthsReportsData: [],
      selectedYear: new Date().getFullYear(),
      yearsPull: [],
      employmentSelect: [
        { value: 'all', label: 'All employment types' },
        { value: 'team_member', label: 'Team member' },
        { value: 'independent', label: 'Independent' },
        { value: 'partner', label: 'Partner' }
      ],
      defaultUserSlots: {
        index: {
          name: 'index'
        },
        name: {
          name: 'name'
        },
        avatar: {
          name: 'avatar'
        },
        action: {
          name: 'action',
          comment: false
        }
      },
      dynamicUserSlots: {},
      showModalOnInit: false,
      showingDetailsRows: [],
      isShowAdjustModal: false,
      currentAdjustUserId: null,
      adjustModalFields: {
        'time_offs_setting': {
          type: 'select',
          name: 'time_offs_settings_id',
          label: 'Time off type',
          selectLabel: 'name',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-6 adjust-field-width'
        },
        'allowed': {
          type: 'slot',
          slotName: 'allowed',
          label: 'Allowed',
          value: null,
          disabled: true,
          class: 'col-12 col-md-6'
        },
        'adjustment_type': {
          type: 'select',
          name: 'adjustment_type',
          label: 'Adjustment type',
          selectLabel: 'label',
          valueField: 'sign',
          options: [{ sign: '+', label: 'Accrue (+)' }, { sign: '-', label: 'Subtract (-)' }],
          value: { sign: '+', label: 'Accrue (+)' },
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-6 adjust-field-width'
        },
        'adjust': {
          type: 'input',
          name: 'adjust',
          label: 'Adjust',
          value: 1,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-6'
        },
        'description': {
          type: 'slot',
          slotName: 'description',
          name: 'description',
          label: 'Description *',
          placeholder: 'Enter description ...',
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-12 col-md-12'
        }
      },
      users: [],
      selectedUser: null,
      selectedUserId: null,
      userFetchError: false
    }
  },
  computed: {
    ...mapGetters({
      timeOffsSettings: 'timeOffsSettings/getTimeOffsSettings',
      allUsers: 'getAllUsersWithTrashed'
    }),
    pageCrumbs () {
      if (this.isPage && this.selectedUser) {
        return [
          {
            text: 'Home',
            to: { name: 'home' }
          },
          {
            text: 'Time off report - detailed',
            to: { name: 'time-off-report' }
          }
        ]
      } else {
        return this.breadcrumbs
      }
    },
    pageTitle () {
      if (this.selectedUser?.name) {
        return this.selectedUser.name
      }
      if (this.selectedUserId && !this.userFetchError) {
        return ''
      }
      return 'Time off report - detailed'
    },
    isPayable () {
      return this.adjustModalFields.time_offs_setting.value && this.adjustModalFields.time_offs_setting.value.is_payable
    },
    adjustAllowedValue () {
      if (!this.adjustModalFields?.time_offs_setting?.value || !this.currentAdjustUserId) {
        return null
      }
      const keyName = (this.adjustModalFields.time_offs_setting.value.name.toLowerCase() + 'timeoffsallowed').replaceAll(' ', '')
      const userData = this.tableData.find(item => item.user.id === this.currentAdjustUserId)
      return userData ? userData[keyName] : null
    },
    monthsSlots () {
      const defaultSlots = {
        month: {
          name: 'month'
        }
      }

      return {
        ...defaultSlots,
        ...this.monthsDynamicSlots,
        ...this.monthsDynamicHeadSlots
      }
    },
    monthsDynamicHeadSlots () {
      const result = {}

      this.monthsDynamicTableColumns.forEach((el) => {
        result[el.key + '.head'] = { name: el.key, type: 'head' }
      })
      return result
    },
    monthsDynamicSlots () {
      const result = {}

      this.monthsDynamicTableColumns.forEach((el) => {
        result[el.key] = { name: el.key }
      })
      return result
    },

    currentYearIndex () {
      if (this.yearsPull.length) {
        return this.yearsPull.indexOf(this.selectedYear)
      }
      return 0
    },
    isLastYearSelected () {
      if (this.currentYearIndex < this.yearsPull.length - 1) {
        return false
      }
      return true
    },
    isFirstYearSelected () {
      if (this.currentYearIndex > 0) {
        return false
      }
      return true
    },
    selectedYearDate () {
      return new Date(this.selectedYear, 0, 1)
    },
    selectedYearData () {
      return this.reportsData.find(
        (report) => report.year === this.selectedYear
      )
    },
    selectedYearMonthsData () {
      if (!this.monthsReportsData || !Array.isArray(this.monthsReportsData)) {
        return null
      }
      return this.monthsReportsData.find(
        (report) => Number(report.year) === Number(this.selectedYear)
      )
    },
    reportGroupsSlots () {
      let groups = {}
      this.selectedYearData.fields.forEach((field) => {
        groups[field + 'head'] = { name: field, type: 'head' }
      })
      return groups
    },

    reportSlots () {
      return {
        ...this.defaultUserSlots,
        ...this.dynamicUserSlots,
        ...this.reportGroupsSlots,
        'worked_days.head': { name: 'worked_days', type: 'head' }
      }
    },
    tableColumns () {
      const defaultCols = [
        {
          key: 'index',
          label: '#',
          class: 'number-column'
        },
        {
          key: 'name',
          label: 'User'
        },
        {
          key: 'worked_days',
          label: 'Workdays passed',
          class: 'text-right'
        },
        {
          key: 'working_days_count',
          label: 'Working days in year',
          class: 'text-right pt-2'
        }
      ]

      const cols = Object.values(this.selectedYearData.year_items[0].user_items)
        .map((userItem) => {
          if (userItem.is_unlimited) {
            return [
              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_used`
                ),
                label: 'Used',
                class: `text-center ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_used`
              }
            ]
          } else {
            return [
              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_allowed`
                ),
                label: 'Allowed',
                class: `text-right ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_allowed`
              },
              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_used`
                ),
                label: 'Used',
                class: `text-right ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_used`
              },

              {
                key: this.formatKey(
                  `${userItem.time_offs_name}_time_offs_left`
                ),
                label: 'Left',
                class: `text-right ${userItem.time_offs_name
                  .toLowerCase()
                  .split(' ')
                  .join('_')}_left`
              }
            ]
          }
        })
        .flat(Infinity)

      return [
        ...defaultCols,
        ...cols,
        {
          key: 'action',
          label: 'Actions',
          class: 'column-controls-md'
        }
      ]
    },
    tableData () {
      return this.getTableData()
    },
    colGroups () {
      const groups = this.selectedYearData?.fields.map((field) => {
        return {
          key: field.toLowerCase(),
          isHead: true,
          icon: this.getTimeOffIcon(field),
          label: field.replaceAll('_', ' '),
          colspan: Object.values(
            this.selectedYearData.year_items[0].user_items
          ).find((f) => f.time_offs_name === field).is_unlimited
            ? 1
            : 3,
          class:
            field.class ||
            'item-width text-right nested-table-left-border nested-table-right-border py-3'
        }
      })

      return [
        { key: 'default', label: '', class: 'width-30p', colspan: 4 },
        ...groups
      ]
    },
    monthsDynamicTableColumns () {
      const dynamicCols = []

      if (this.selectedYearMonthsData) {
        this.colGroups.forEach((item) => {
          if (item.isHead) {
            const findedItem = this.selectedYearMonthsData?.items.find(
              (el) => el?.type?.toLowerCase() === item?.label?.toLowerCase()
            )
            if (findedItem) {
              let summDays = this.monthsTableData.reduce((acc, it) => {
                if (it.items.length) {
                  it.items.forEach((e) => {
                    if (e.type?.toLowerCase() === item.key?.toLowerCase()) {
                      acc += e.days
                    }
                  })
                }
                return acc
              }, 0)

              dynamicCols.push({
                key: item.label,
                class:
                  'text-center item-width nested-table-left-border nested-table-right-border',
                label: {
                  text: item.label.toUpperCase(),
                  value: summDays + ' d',
                  icon: this.getTimeOffIcon(item.label)
                }
              })
            } else {
              dynamicCols.push({
                key: item.label,
                class:
                  'text-center item-width nested-table-left-border nested-table-right-border',
                label: {
                  text: item?.label?.toUpperCase(),
                  value: 0 + ' d',
                  icon: this.getTimeOffIcon(item.label)
                }
              })
            }
          }
        })
      }

      return dynamicCols
    },

    monthsTableColumns () {
      const columns = {
        key: 'month',
        label: 'Months',
        class: 'width-30p',
        style: 'background-color: white;'
      }
      return [
        columns,
        ...this.monthsDynamicTableColumns,
        { key: 'action', label: '', class: 'column-controls-md' }
      ]
    },

    shouldUseFullWidth () {
      // Use full width when there are many columns (more than a threshold)
      // Calculate estimated table width based on column count
      const fixedColumnsWidth = 42 + 188 + 67 + 67 // index, name, worked days, working days
      const dynamicColumnsCount = this.colGroups ? this.colGroups.filter(col => col.isHead).length : 0
      const dynamicColumnsWidth = dynamicColumnsCount * 170 // average column width
      const actionsColumnWidth = 60
      const estimatedTableWidth = fixedColumnsWidth + dynamicColumnsWidth + actionsColumnWidth

      // Use full width if estimated table width exceeds viewport or if many columns
      return estimatedTableWidth > window.innerWidth
    },

    shouldUseFullWidthForMonths () {
      // Use full width for months table when there are many columns
      // Calculate estimated table width based on month table column count
      const monthsFixedColumnWidth = 353 // months column
      const monthsDynamicColumnsCount = this.monthsDynamicTableColumns ? this.monthsDynamicTableColumns.length : 0
      const monthsDynamicColumnsWidth = monthsDynamicColumnsCount * 170 // average column width
      const monthsActionsColumnWidth = 45
      const estimatedMonthsTableWidth = monthsFixedColumnWidth + monthsDynamicColumnsWidth + monthsActionsColumnWidth
      // Use full width if estimated table width exceeds viewport or if many columns
      return estimatedMonthsTableWidth > window.innerWidth
    },

    monthsTableData () {
      let result = [
        { month: 'January', items: [] },
        { month: 'February', items: [] },
        { month: 'March', items: [] },
        { month: 'April', items: [] },
        { month: 'May', items: [] },
        { month: 'June', items: [] },
        { month: 'July', items: [] },
        { month: 'August', items: [] },
        { month: 'September', items: [] },
        { month: 'October', items: [] },
        { month: 'November', items: [] },
        { month: 'December', items: [] }
      ]
      // eslint-disable-next-line
      this.selectedYearMonthsData?.items.forEach((entry) => {
        if (!entry.items || !Array.isArray(entry.items)) return
        entry.items.forEach((monthItem) => {
          if (!monthItem.month || typeof monthItem.days !== 'number') return

          result.forEach((el) => {
            if (el.month === monthItem.month) {
              const summ = monthItem.items.reduce(
                (acc, el) => acc + el.days,
                0
              )
              el.items.push(
                ...monthItem.items.map((el) => ({
                  date:
                    el.start === el.end
                      ? this.formatDate(el.start)
                      : this.formatDate(el.start) + ' - ' + this.formatDate(el.end),
                  days: el.days,
                  type: entry.type
                }))
              )
              el.summ = summ
            }
          })
        })
      })
      return result
    },
    userOptions () {
      return this.allUsers.length > 0 ? this.allUsers : this.users
    }
  },
  async mounted () {
    if (this.timeOffReportUserId) {
      this.selectedUserId = this.timeOffReportUserId
    } else {
      this.selectedUserId = null
      this.selectedUser = null
    }

    if (!this.isPage) {
      window.addEventListener('popstate', this.handleBackButton)
    }

    this.isLoading = true

    try {
      const promises = []

      if (this.selectedUserId && !this.timeOffReportUser && !this.timeOffReportUserId) {
        promises.push(
          this.$api.users.getUser(this.selectedUserId)
            .then(({ data }) => {
              this.selectedUser = data
              this.users.push(data)
              this.userFetchError = false
            })
            .catch((error) => {
              this.userFetchError = true
              throw error
            })
        )
      }

      promises.push(this.fetchTimeOffsSettings())
      promises.push(this.getUsers())
      await Promise.all(promises)
    } catch (error) {
      this.errorNotifications(error)
    } finally {
      this.isLoading = false
    }

    if (this.timeOffReportUser) {
      this.selectedUser = this.timeOffReportUser
    } else if (this.timeOffReportUserId) {
      // Try to find user in store first, then in local users array
      this.selectedUser = this.allUsers.find(user => user.id === this.timeOffReportUserId) ||
                         this.users.find(user => user.id === this.timeOffReportUserId) || null
    }
  },
  beforeDestroy () {
    if (!this.isPage) {
      window.removeEventListener('popstate', this.handleBackButton)
    }
  },
  watch: {
    yearsPull (newValue) {
      if (newValue && newValue.length) {
        if (!newValue.includes(this.selectedYear)) {
          this.selectedYear = Math.max(...newValue)
        }
      }
    },
    selectedYear () {
      this.detailsData = {}
    },
    adjustAllowedValue (newValue) {
      this.adjustModalFields.allowed.value = newValue
    },
    selectedUser (newSelectedUser) {
      if (newSelectedUser) {
        if (this.isPage) {
          // this.$router.replace({ name: 'time-off-report-id', params: { id: newSelectedUser.id } })
        } else {
          // this.$router.replace({ name: 'time-off-report-id', params: { id: newSelectedUser.id } })
          // window.location.replace(this.$router.resolve({ name: 'time-off-report-id', params: { id: newSelectedUser.id } }).href)
          // }
        }
      }
    },
    selectedUserId (newSelectedUserId) {
      this.userFetchError = false
      if (newSelectedUserId) {
        this.selectedUser =
          this.allUsers.find((user) => user.id === newSelectedUserId) ||
          this.users.find((user) => user.id === newSelectedUserId) || null
        this.getTimeOffsUserData(newSelectedUserId)
      } else {
        this.selectedUser = null
        this.reportsData = []
        this.monthsReportsData = []
        this.yearsPull = []
        this.isLoading = false
      }
    },
    timeOffReportUserId (newUserId) {
      if (newUserId) {
        this.selectedUserId = newUserId
      } else {
        this.selectedUserId = null
        this.selectedUser = null
      }
    }
  },
  methods: {
    ...mapActions(['setAllUsers']),
    handleBackButton () {
      if (this.onClose) {
        this.onClose()
      }
    },
    getUsers () {
      // If users are already in the store, use them instead of fetching
      if (this.allUsers.length > 0) {
        this.users = [...this.allUsers]
        return Promise.resolve()
      }

      return this.axios({
        method: 'post',
        url: '/api/users-with-trashed',
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
        .then(response => {
          this.users = [...this.users, ...response.data]
          // Store users in Vuex for future use
          this.setAllUsers(response.data)
        })
        .catch(console.error)
    },
    showDetails (row) {
      if (this.showingDetailsRows.includes(row.month)) {
        this.showingDetailsRows = this.showingDetailsRows.filter(
          (item) => item !== row.month
        )
      } else {
        this.showingDetailsRows.push(row.month)
      }
    },
    async fetchTimeOffsSettings () {
      return this._toggleDataPageLoading(() =>
        this.$api.timeOffsSettings.getTimeOffsSettings()
      )
    },
    async getTimeOffsUserData (userId) {
      if (!userId) {
        this.isLoading = false
        return
      }
      this.isLoading = true
      await this.axios
        .post(
          '/api/report/timeOffs',
          { user_ids: [userId] },
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.reportsData =
              response.data?.user_worked_days_report || response.data

            this.monthsReportsData = response.data?.time_offs_report?.[0] || []
            this.yearsPull = this.reportsData
              .map((el) => el.year)
              .sort((a, b) => a - b)
          }
        })
        .catch(console.error).finally(() => {
          this.isLoading = false
        })
    },

    async fetchAdustments (userId, year) {
      const response =
        await this.$api.timeOffsAdjustments.fetchTimeOffsAdjustments(
          userId,
          year
        )
      return response.data
    },

    previousYearClick () {
      if (this.currentYearIndex > 0) {
        this.selectedYear = this.yearsPull[this.currentYearIndex - 1]
      }
    },
    nextYearClick () {
      if (this.currentYearIndex < this.yearsPull.length - 1) {
        this.selectedYear = this.yearsPull[this.currentYearIndex + 1]
      }
    },
    handleYearChange (direction) {
      if (direction === 'prev') {
        this.previousYearClick()
      } else if (direction === 'next') {
        this.nextYearClick()
      }
    },
    handleYearSelect (date, type) {
      this.selectedYear = date.getFullYear()
    },
    getNumber (index) {
      if (this.currentPage > 1) {
        const curPage = this.currentPage - 1
        return this.perPage * curPage + index
      } else {
        return index
      }
    },
    updateTable (data) {
      this.currentPage = data.currentPage
      this.perPage = data.perPage
    },
    async fetchAdustmentsHandler (userId) {
      try {
        this.userDetailsDataLoading = userId
        const data = await this.fetchAdustments(userId, this.selectedYear)
        this.detailsData = {
          ...this.detailsData,
          [userId]: data
        }

        // Scroll to the left after data is loaded
        this.$nextTick(() => {
          const tableWrapper = document.querySelector('.table-responsive-wrapper')
          if (tableWrapper) {
            tableWrapper.scrollLeft = 0
          }
        })
      } catch (error) {
        console.error(error)
      } finally {
        this.userDetailsDataLoading = 0
      }
    },
    async visibilityActionClick (slotProps) {
      this.showModalOnInit = false
      const userId = slotProps.item.user.id

      slotProps.toggleDetails()
      if (slotProps.detailsShowing === false) {
        // load data if we are opening details. detailsShowing === false means that details are closed at the moment
        await this.fetchAdustmentsHandler(userId)
      }
    },
    resetAdjustModalFields () {
      this.adjustModalFields.time_offs_setting.value = null
      this.adjustModalFields.allowed.value = null
      this.adjustModalFields.adjustment_type.value = { sign: '+', label: 'Accrue (+)' }
      this.adjustModalFields.adjust.value = 1
      this.adjustModalFields.description.value = null
    },
    handleEditClick (userId) {
      this.resetAdjustModalFields()

      this.currentAdjustUserId = userId
      this.initAdjustModal()
      this.isShowAdjustModal = true
    },
    initAdjustModal () {
      this.adjustModalFields.time_offs_setting.options = this.timeOffsSettings
      this.adjustModalFields.time_offs_setting.value = this.timeOffsSettings[0]
    },
    closeAdjustModal () {
      this.isShowAdjustModal = false
      this.currentAdjustUserId = null

      // Clear FormGenerator validation before resetting values
      if (this.$refs.form && this.$refs.form.clearValidation) {
        this.$refs.form.clearValidation()
      }
    },
    updateAdjustModalItem (key, itemData) {
      this.adjustModalFields[key] = itemData
    },
    updateDescriptionValue (value) {
      this.adjustModalFields.description.value = value
    },
    submitAdjustment (fields) {
      const data = this.prepareFormFieldsForRequest(fields)
      data['user_id'] = this.currentAdjustUserId
      data['year'] = this.selectedYear
      this.$api.timeOffsAdjustments.addTimeOffsAdjustment(data)
        .then(async () => {
          this.$snotify.success(
            'Time off successfully adjusted',
            'Success',
            this.$store.state.snotify
          )
          this.dataUpdated(this.currentAdjustUserId)
          this.closeAdjustModal()
        })
        .catch((error) => {
          this.errorNotifications(error)
        })
    },
    prepareFormFieldsForRequest (fields) {
      let data = {}
      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        const value = field['value']
        if (!value) {
          continue
        }
        data[name] = typeof value === 'object' && !(value instanceof Array) ? value[field['valueField']] : value
      }
      return data
    },
    formatDate (dateString) {
      // Parse the date and set it to the selected year
      const date = moment(dateString).year(this.selectedYear)
      return date.format('DD.MM.YYYY')
    },
    getTableData () {
      if (!this.selectedYearData) return []

      const arr =
        this.selectedYearData.year_items
      const result = arr.map((el) => {
        let item = {
          user: el.user,
          worked_days: el.worked_days,
          working_days_count: this.selectedYearData.working_days_count
        }

        Object.values(el.user_items).forEach((x) => {
          if (x.is_unlimited) {
            item = {
              ...item,
              [this.formatKey(`${x.time_offs_name}_time_offs_used`)]:
                x.time_offs_used
            }
          } else {
            let key = this.formatKey(`${x.time_offs_name}_time_offs_allowed`)

            item = {
              ...item,
              [this.formatKey(`${x.time_offs_name}_time_offs_allowed`)]:
                x.time_offs_allowed,
              [this.formatKey(`${x.time_offs_name}_time_offs_used`)]:
                x.time_offs_used,
              [this.formatKey(`${x.time_offs_name}_time_offs_left`)]:
                x.time_offs_allowed + x.time_offs_adjust - x.time_offs_used,
              [this.formatKey(`${x.time_offs_name}_time_offs_allowed_adjust`)]:
                x.time_offs_adjust
            }

            this.dynamicUserSlots[key] = { name: key }
          }
        })
        return item
      })

      return result
    },
    formatKey (str) {
      return str.replace(/[_\s]/g, '').toLowerCase()
    },
    async dataUpdated (userId) {
      try {
        this.userDetailsDataLoading = userId
        await this.getTimeOffsUserData(userId)
        const data = await this.fetchAdustments(userId, this.selectedYear)
        this.detailsData = {
          ...this.detailsData,
          [userId]: data
        }

        const el = document.getElementById(`${userId}-action`)

        el.dispatchEvent(
          new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          })
        )

        this.userDetailsDataLoading = 0
      } catch (error) {
        console.error(error)
      }
    },
    onClose () {
      this.$emit('close')
    },
    getTimeOffIcon (settingName) {
      if (!this.timeOffsSettings.length) {
        return null
      }
      const setting = this.timeOffsSettings.find(
        (setting) => setting.name === settingName
      )
      return setting || null
    },
    getColumnMinWidth (columnText, offsetPx = 0) {
      // Find the corresponding column in colGroups by matching the label text
      const matchingColumn = this.colGroups.find(col =>
        col.label && col.label.toLowerCase() === columnText.toLowerCase()
      )

      let baseWidth
      if (matchingColumn) {
        baseWidth = matchingColumn.colspan === 1 ? 121 : 170
      } else {
        baseWidth = 170 // default fallback
      }

      return (baseWidth + offsetPx) + 'px'
    },
    getReportPage (data) {
      if (this.isPage) {
        this.$router.push({ name: 'time-off-report-id', params: { id: data.id } })
      } else {
        // In slideout mode, just update the selected user directly without navigation
        this.selectedUserId = data.id
      }
    },
    getMonthTimeOffSum (monthItem, timeOffType) {
      if (!monthItem.items || !monthItem.items.length) {
        return ''
      }

      const totalDays = monthItem.items
        .filter(item => item.type.toLowerCase() === timeOffType.toLowerCase())
        .reduce((sum, item) => sum + item.days, 0)

      return totalDays > 0 ? `${totalDays} d` : ''
    }
  }
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.time-log-loader.preloader-wrapper {
  z-index: 500 !important;
}

// Global styles to override validation green borders in modal
.modal .form-control.is-valid,
.b-modal .form-control.is-valid,
.modal .multiselect.is-valid,
.b-modal .multiselect.is-valid,
.modal .multiselect__input.is-valid,
.b-modal .multiselect__input.is-valid,
.modal .vue-multiselect.is-valid,
.b-modal .vue-multiselect.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

.modal .form-control.is-valid:focus,
.b-modal .form-control.is-valid:focus,
.modal .multiselect.is-valid:focus,
.b-modal .multiselect.is-valid:focus {
  border-color: #80bdff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

.modal textarea.is-valid,
.b-modal textarea.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

// Override multiselect validation borders
.modal .multiselect.is-valid .multiselect__tags,
.b-modal .multiselect.is-valid .multiselect__tags {
  border-color: #ced4da !important;
}

.modal .vue-multiselect.is-valid .multiselect__tags,
.b-modal .vue-multiselect.is-valid .multiselect__tags {
  border-color: #ced4da !important;
}
</style>

<style lang="scss" scoped>
// Remove green validation borders for successful validation
::v-deep .modal .form-control.is-valid,
::v-deep .b-modal .form-control.is-valid,
::v-deep .form-control.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

::v-deep .modal .form-control.is-valid:focus,
::v-deep .b-modal .form-control.is-valid:focus,
::v-deep .form-control.is-valid:focus {
  border-color: #80bdff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

// Also handle textarea specifically
::v-deep .modal textarea.is-valid,
::v-deep .b-modal textarea.is-valid,
::v-deep textarea.is-valid {
  border-color: #ced4da !important;
  background-image: none !important;
}

.remove-hover {
  pointer-events: none !important;
}

.add-hover {
  pointer-events: all !important;
}

.time-off-report-page {
  .header-gap {
    gap: 15px;
  }

  .actions-wrap {
    color: $iconColorAccent;
    display: flex;
    align-items: center;
    justify-content: right;
    gap: 4px;

    & .material-symbols-outlined {
      font-size: 20px;
    }

    & span {
      cursor: pointer;
    }
  }

  ::v-deep th.nested-table-left-border {
    border-left: 1px solid #e3e7ee !important;
  }

  ::v-deep th.nested-table-right-border {
    border-right: 1px solid #e3e7ee !important;
  }

  ::v-deep.item-width {
    width: 240px !important;
  }
}

::v-deep.b-table-details>td {
  padding: 0 !important;
}

::v-deep.table__theme-default>.table-container {
  padding-top: 0;
}

::v-deep.table-responsive-wrapper>.table-fullscreen>.table-container {
  padding-left: 0;
  border-radius: 0;
}

::v-deep .table-title {
  font-size: 18px;
  line-height: 30px;
  font-weight: 500;
}

.detailed-dates-row {
  padding-top: unset;
  border: none;

  td {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

::v-deep .py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

/* Completely hide nested table thead content */
::v-deep thead[style*="visibility: hidden"] {
  height: 0 !important;
  visibility: hidden;
}

::v-deep thead[style*="visibility: hidden"] * {
  height: 0 !important;
  visibility: hidden;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

::v-deep .main-head {
  margin-top: 4px;
}

::v-deep .nested-table>table>thead,
::v-deep .nested-table>table tbody tr:nth-child(even) {
  background-color: rgba(228, 231, 238, 0.5) !important;
}

::v-deep .nested-table>table>thead tr:hover {
  background-color: unset;
}

::v-deep .nested-table>table tbody tr:nth-child(odd) {
  background-color: rgba(243, 245, 247, 0.5) !important;
}

.table-responsive-outter-wrapper {
  padding: 0 16px;
  border-radius: 10px;
  background-color: white;
}

// Horizontal scroll wrapper
.table-responsive-wrapper {
  background-color: white;
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: visible;

  // Custom scrollbar styling
  &::-webkit-scrollbar {
    height: 8px;
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: #E3E7EE;
    border-radius: 25px;
    margin: 0 18px;
  }

  &::-webkit-scrollbar-thumb {
    background: #C5CBDA;
    border-radius: 25px;

    &:hover {
      background: #B0B0C8;
    }
  }

  // Firefox scrollbar
  scrollbar-width: thin;
  scrollbar-color: #C5CBDA #E3E7EE;

  .time-off-user-table {

    ::v-deep .table-hover tbody tr,
    ::v-deep .main-head {
      background-color: white;
    }

    // Sticky columns for first 4 columns
    ::v-deep .table .main-head th:nth-child(1),
    ::v-deep .table td:nth-child(1) {
      position: sticky;
      padding-left: 25px;
      left: 0px;
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table .main-head th:nth-child(2),
    ::v-deep .table td:nth-child(2) {
      position: sticky;
      min-width: 188px;
      max-width: 188px;
      left: 12px; // width of first column
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table .main-head th:nth-child(3),
    ::v-deep .table td:nth-child(3) {
      position: sticky;
      left: 200px; // width of first two columns
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table .main-head th:nth-child(4),
    ::v-deep .table td:nth-child(4) {
      position: sticky;
      left: 295px; // width of first three columns
      z-index: 2;
      background-color: inherit;
    }

    ::v-deep .table:not(.main-head) th:nth-child(1) {
      position: sticky;
      left: 0;
      z-index: 2;
      background-color: white;
    }
  }
}

.used-by-months-table-wrapper {
  padding: 20px 16px;
  background-color: white;
  border-radius: 10px;
}

::v-deep .used-by-months-table-wrapper .table-title {
  left: 0;
  z-index: 2;
  position: sticky;
  width: 200px;
}

::v-deep .used-by-months-table tr th:first-child,
::v-deep .used-by-months-table tr td:first-child {
  min-width: 365px;
  max-width: 365px;
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: inherit;
}

::v-deep .used-by-months-table tr {
  background-color: white;
}

::v-deep .used-by-months-table .column-controls-md {
  min-width: 45px;
}

::v-deep .months-subtable tr {
  background-color: #F3F5F7;
}

::v-deep .super .empty-state {
  padding-top: 10px;
}

// ::v-deep .super.page .empty-state {
// border-top-left-radius: 0px !important;
// border-top-right-radius: 0px !important;
// }
</style>
